module.exports = "<div>\r\n    <label for=\"{{id}}\" class=\"control-label {{to.labelSrOnly ? 'sr-only' : ''}}\" ng-if=\"to.label\">\r\n        {{to.label}}\r\n        <span ng-if=\"to.required\">{{to.required ? '*' : ''}}</span>\r\n    </label>\r\n    <formly-transclude></formly-transclude>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./static/js/app/layout/formly/wrappers/label.html
// module id = 625
// module chunks = 1